<template>
  <div class="container">
    <button class="fancy-button" @click="switchPage" >设置</button>
    <div class="lucky-wheel">
<!--      <div class="lucky-title"></div>-->
      <div class="wheel-main">
       <LuckyWheel
         ref="myLucky"
          :width="wheelSize"
          :height="wheelSize"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          :default-style="defaultStyle"
          @start="startCallback"
          @end="endCallback"
       />
      </div>
    </div>

    <div class="toast" v-show="prize">
      <div class="toast-container">
        <div class="toast-picture-parent">
          <img :src="toastIcon" class="toast-picture" />
        </div>
        <div class="close" @click="closeToast()"></div>
        <div class="toast-title">{{toastTitle}}</div>
        <div class="toast-btn">
          <div class="toast-cancel" @click="closeToast">关闭</div>
        </div>
      </div>
    </div>
    <div class="toast-mask" v-show="prize"></div>
  </div>
</template>
<script>
import { EventBus } from '../event-bus.js';
import { API_URL } from '../constant.js';

export default {
  data() {
    return {
      prize: null,
      blocks: [{ padding: '13px', background: '#fb3a13' }],
      defaultStyle: {
        fontColor: '#FFFFFF',
        fontSize: '1rem',
      },
      prizes: [
        // {isPrize : 1,id: 2, fonts: [{ text: 'iPhone 16 Pro Max',top: '15%', }], background: "#FF5733", range: 15, imgs:[{top: '30%', width:"180px", src: require("../assets/img/bean_500.png") }] },
        // {isPrize : 1,id: 3, fonts: [{ text: 'iPhone 15 Pro Max',top: '15%',  }], background: "#fc820a", range: 15, imgs:[{top: '30%', width:"180px", src: require("../assets/img/bean_500.png") }] },
        // {isPrize : 1,id: 4, fonts: [{ text: 'iPhone 14 Pro Max',top: '15%',  }], background: "#FF5733", range: 15, imgs:[{top: '30%', width:"180px", src: require("../assets/img/bean_500.png") }] },
        // {isPrize : 1,id: 5, fonts: [{ text: 'iPhone 13 Pro Max',top: '15%',  }], background: "#fc820a", range: 15, imgs:[{top: '30%', width:"180px", src: require("../assets/img/bean_500.png") }] },
        // {isPrize : 1,id: 6, fonts: [{ text: 'iPhone 12 Pro Max',top: '15%',  }], background: "#152d68", range: 15, imgs:[{top: '30%', width:"180px", src: require("../assets/img/bean_500.png") }] },
      ],
      buttons: [{
        radius: '20%',
        pointer: false,
        imgs:[
          {src:  require("../assets/img/pointer.png"), top:'-71px', height:'142px'},
        ]
      }],
    };
  },

  computed: {
    wheelSize() {
      return window.innerHeight * 0.6 + 'px';
    },
    toastTitle () {
      return this.prize && this.prize.isPrize === 1
        ? "恭喜您获得\n" +
            this.prize.fonts[0].text
        : "未中奖";
    },
    toastIcon() {
      return this.prize && this.prize.imgs[0].src
    }
  },

  created() {
    this.fetchData()
    EventBus.$on('switch', (message) => {
      this.fetchData()
    });
  },
  beforeDestroy() {
    EventBus.$off('switch');
  },
  methods: {
    async fetchData() {
      try {
        // 发送 GET 请求
        const response = await fetch(`${API_URL}/get-config`);
        const data = await response.json();
        const imgWidth = this.calcImgWidth(data.length);

        // 给每个 prize 自动设置图片宽度
        this.prizes = data.map(item => {
          if (item.imgs && item.imgs.length > 0) {
            item.imgs[0].width = imgWidth;
          }
          return item;
        });

      } catch (error) {
        console.error("There was an error fetching the data:", error);
      }
    },

    calcImgWidth(length) {
      const size = parseFloat(window.innerHeight * 0.6); // 去掉 px
      const n = length;

      if (!n) return '0px';

      const R = size / 2;

      // 每个扇形对应的弦长
      const chord = 2 * R * Math.sin(Math.PI / n);

      // 稍微缩小一点，避免溢出（比如 40%）
      const width = chord * 0.4;

      return Math.floor(width) + 'px';
    },

    switchPage(){
      this.$emit('switch')
      EventBus.$emit('switch');
    },
    // 点击抽奖按钮会触发star回调
    startCallback () {
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play()
      // 模拟调用接口异步抽奖
      setTimeout(() => {
        // 假设后端返回的中奖索引是0
        // const index = 0
        // 调用stop停止旋转并传递中奖索引
        // this.$refs.myLucky.stop(index)
        this.$refs.myLucky.stop()
      }, 3000)
    },
    // 抽奖结束会触发end回调
    endCallback (prize) {
      console.log(prize)
      this.prize = prize
    },
    closeToast() {
      this.prize = null;
    }
  }
};
</script>
<style scoped>


.container {
  width: 100vw;
  height: 100vh;
  overflow: hidden; /* 防止内容溢出时出现滚动条 */
}
.lucky-wheel {
  height: 100%;
  width: 100%;
  background: rgb(255 255 255) url("../assets/img/bg.jpg") no-repeat center;
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lucky-title {
  width: 100%;
  height: 12rem;
  background: url("../assets/img/lucky_title.png") no-repeat center;
  background-size: contain;
}
.wheel-main {
  /* 样式已移至 .lucky-wheel 以使用 Flexbox 居中 */
}
.wheel-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-size: 100%;
  color: #fff;
}
.bg2 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  //z-index: -1;
  transform: translate(-50%, -50%);
}

.wheel-bg div {
  text-align: center;
}
.prize-list {
  width: 100%;
  height: 100%;
  position: relative;
}
.prize-list .prize-item {
  position: absolute;
  width: 95px;
  height: 150px;
  top: 0;
  left: 50%;
  margin-left: -47.5px;
  transform-origin: 50% 100%;
}

.prize-pic img {
  width: 4.0625rem;
  height: 2.5rem;
  margin-top: 1.5625rem;
}
.prize-count {
  font-size: 0.875rem;
}
.prize-type {
  font-size: 0.75rem;
}
.main {
  position: relative;
  width: 100%;
  min-height: 14.25rem;
  background: rgb(243, 109, 86);
  padding-bottom: 1.6875rem;
}

.bg-p {
  width: 100%;
  height: 2.95rem;
  background: rgb(252, 207, 133);
}
.content {
  position: absolute;
  top: 0.175rem;
  left: 0;
  background: rgb(243, 109, 86);
  width: 100%;
  height: 5.1875rem;
  font-size: 1.125rem;
  color: #ffeb39;
  padding-left: 6.75rem;
}
.content div {
  text-align: left;
}
.tip {
  position: relative;
  margin: 2.5rem auto 0;
  width: 17.5rem;
  border: 1px solid #fbc27f;
}
.tip-title {
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 1rem;
  color: #fccc6e;
  background: rgb(243, 109, 86);
  padding: 0.3125rem 0.625rem;
}
.tip-content {
  padding: 1.5625rem 0.625rem;
  font-size: 0.875rem;
  color: #fff8c5;
  line-height: 1.5;
}
.toast-mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  width: 100%;
  height: 100%;
}
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 20000;
  transform: translate(-50%, -50%);
  width: 15.4375rem;
  background: #fff;
  border-radius: 0.3125rem;
  padding: 0.3125rem;
  background-color: rgb(252, 244, 224);
}
.toast-container {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px dotted #fccc6e;
}

.toast-picture-parent {
  position: absolute;
  top: -10rem;
  left: -1.5rem;
}
.toast-picture {
  width: 18.75rem;
  height: 8.5625rem;
}
.toast-pictrue-change {
  position: absolute;
  top: -1.5rem;
  left: -1.375rem;
  width: 17.5rem;
  height: 3.125rem;
}
.toast-title {
  white-space: pre-line;
  padding: 2.8125rem 0;
  font-size: 18px;
  color: #fc7939;
  text-align: center;
}
.toast-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.9375rem;
}
.toast-btn div {
  background-image: -moz-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );

  background-image: -ms-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );
  background-image: -webkit-linear-gradient(
    -18deg,
    rgb(242, 148, 85) 0%,
    rgb(252, 124, 88) 51%,
    rgb(252, 124, 88) 99%
  );
  box-shadow: 0px 4px 0px 0px rgba(174, 34, 5, 0.7);
  width: 4.6875rem;
  height: 1.875rem;
  border-radius: 1.875rem;
  text-align: center;
  line-height: 1.875rem;
  color: #fff;
}
.close {
  position: absolute;
  top: -0.9375rem;
  right: -0.9375rem;
  width: 2rem;
  height: 2rem;
  background: url("../assets/img/close_store.png") no-repeat center top;
  background-size: 100%;
}

.fancy-button {
  width: 120px;
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: linear-gradient(45deg, #ff6b6b, #f06595); /* 渐变背景色 */
  color: #fff; /* 字体颜色 */
  border: none; /* 无边框 */
  padding: 12px 24px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  font-size: 16px; /* 字体大小 */
  font-weight: bold; /* 字体加粗 */
  cursor: pointer; /* 鼠标样式 */
  transition: all 0.3s ease; /* 动画过渡 */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06); /* 阴影效果 */
}

.fancy-button:hover {
  background: linear-gradient(45deg, #f06595, #ff6b6b); /* 悬停渐变颜色反转 */
  transform: translateY(-2px); /* 悬停微动效果 */
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.08);
}

</style>



// WEBPACK FOOTER //
// src/components/luckywheel.vue